import { FC } from 'react';
import {
  WbDockableGroup,
  WbDockablePanel,
  WbDockableResizeHandle,
} from '@agilelab/plugin-wb-platform';
import { configApiRef, useApi } from '@mainstage/core-plugin-api';
import { EditorCard } from './EditorCard/EditorCard';
import { EditorPageEnvironmentLoader } from './EditorPageEnvironmentLoader';
import { TestCard } from './TestCard/TestCard';
import { TestCardActions } from './TestCard/TestCardActions';

const EditorPageContent: FC = () => {
  const configApi = useApi(configApiRef);
  const isTestMinimized =
    configApi.getOptionalBoolean('catalog.editor.testMinimized') ?? true;

  /*
   * For react-resizable-panels, the defaultSize prop is used to set the initial size of the panel, and the minSize prop is used to set the minimum size of the panel when it is resized.
   * In this case, if isTestMinimized is true, the default size of the test panel will be set to 3%, and if it is false, the default size will be set to 30%. The minSize is set to 35% to ensure that the panel cannot be resized smaller than that.
   */
  return (
    <WbDockableGroup direction="horizontal">
      <WbDockablePanel>
        <EditorCard />
      </WbDockablePanel>
      <WbDockableResizeHandle direction="horizontal" spacing />
      <WbDockablePanel
        primary
        defaultSize={isTestMinimized ? 3 : 30}
        minSize={35}
        title="Test"
        headerBorderBottom
        headerActions={<TestCardActions />}
        cardWrapper
      >
        <TestCard />
      </WbDockablePanel>
    </WbDockableGroup>
  );
};

export const EditorPage: FC = () => {
  return (
    <EditorPageEnvironmentLoader>
      <EditorPageContent />
    </EditorPageEnvironmentLoader>
  );
};
